import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { StatesByRegion } from '../models/states-by-region';

export const GetStatesByRegion = createAsyncThunk(
    'locations/getStatesByRegion',
    async (_, { getState }: any) => {
        const axios = getState().core.axios;
        try {
            const response = await axios.get('/api/Location/StatesByRegion');
            if (response && response.data && response.data.data) {
                const statesByRegion = response.data.data as StatesByRegion[];
                return {
                    statesByRegion,
                };
            }
            return {
                statesByRegion: [],
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching States',
                'error'
            );
            throw error;
        }
    }
);
